export const formatLength = (meters: number): string => {
    if (meters > 1000) {
        return `${(meters / 1000).toFixed(2)}km`
    }

    return `${Math.round(meters)}m`
}

export const formatArea = (squareMeters: number) => {
    if (squareMeters < 10000) {
        return `${Math.round(squareMeters * 100) / 100}m²`
    } else {
        const hectares = squareMeters / 10000
        if (hectares < 100) {
            return `${Math.round(hectares * 100) / 100}ha`
        } else {
            const squareKm = squareMeters / 1000000
            return `${Math.round(squareKm * 100) / 100}km²`
        }
    }
}